module.exports = __webpack_public_path__ + "static/media/arrow-cs-logo.381a7781.png";